import { initializeApp, getApps } from 'firebase/app';
import { ENV } from '@configs/env';

let app;
const SECONDARY_APP_NAME = 'school-crm-secondary-auth';

/**
 * Single Firebase app instance for the CRM web client.
 */
export function getFirebaseApp() {
    if (getApps().length) {
        return getApps()[0];
    }
    if (!ENV.FIREBASE?.apiKey) {
        throw new Error(
            'Firebase is not configured. Set VITE_FIREBASE_* variables (see .env.example).'
        );
    }
    app = initializeApp(ENV.FIREBASE);
    return app;
}

/**
 * Secondary Firebase app instance used for privileged flows (e.g. creating a tenant admin user)
 * without affecting the owner’s current auth session.
 */
export function getSecondaryFirebaseApp() {
    const existing = getApps().find((a) => a.name === SECONDARY_APP_NAME);
    if (existing) return existing;
    if (!ENV.FIREBASE?.apiKey) {
        throw new Error('Firebase is not configured. Set VITE_FIREBASE_* variables (see .env.example).');
    }
    return initializeApp(ENV.FIREBASE, SECONDARY_APP_NAME);
}
